// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AllocationCampaignFooterCmp from "../reusable-components/AllocationCampaignFooterCmp.bs.js";

function ManagePriorityFooter(Props) {
  var formDirty = Props.formDirty;
  var user_role = Props.user_role;
  var createCampaignHandler = Props.createCampaignHandler;
  var resetClickHandler = Props.resetClickHandler;
  var submitClickHandler = Props.submitClickHandler;
  var match = user_role.access_level;
  if (match >= 2) {
    return null;
  } else if (formDirty) {
    return React.createElement(AllocationCampaignFooterCmp.make, {
                onLeftBtnClick: resetClickHandler,
                leftBtnText: "Reset",
                onRightBtnClick: submitClickHandler,
                rightBtnText: "Submit"
              });
  } else {
    return React.createElement(AllocationCampaignFooterCmp.make, {
                onLeftBtnClick: (function (param) {
                    
                  }),
                leftBtnText: "",
                onRightBtnClick: createCampaignHandler,
                rightBtnText: "Create New Campaign"
              });
  }
}

var make = ManagePriorityFooter;

export {
  make ,
  
}
/* react Not a pure module */
